import { render } from "./WaitingRoom.vue?vue&type=template&id=8a5e350a&ts=true"
import script from "./WaitingRoom.vue?vue&type=script&lang=ts"
export * from "./WaitingRoom.vue?vue&type=script&lang=ts"

import "./WaitingRoom.vue?vue&type=style&index=0&id=8a5e350a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__